import { render, staticRenderFns } from "./MarkDown.vue?vue&type=template&id=5d15276d&"
import script from "./MarkDown.vue?vue&type=script&lang=js&"
export * from "./MarkDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports